import { render, staticRenderFns } from "./SettingsTagSelectMenu.vue?vue&type=template&id=4964acde&scoped=true&"
import script from "./SettingsTagSelectMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsTagSelectMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTagSelectMenu.vue?vue&type=style&index=0&id=4964acde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964acde",
  null
  
)

export default component.exports